import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "fetch-bitpanda-user" }
const _hoisted_2 = {
  key: 0,
  class: "fetch-bitpanda-user__loading"
}

import { defineAsyncComponent, shallowRef, type PropType } from 'vue';

import { accountService } from '@exchange/libs/account/service/src';
import { usePromiseWithCB } from '@exchange/libs/composables/shared/src/lib/usePromise';
import { featureRestrictionsService } from '@exchange/libs/feature-restrictions/service/src';
import { modalService, type ModalVariant } from '@exchange/libs/modals/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'FetchBitpandaUser',
  props: {
  variant: { type: String as PropType<ModalVariant>, required: true },
},
  setup(__props) {

const ErrorModal = defineAsyncComponent(() => import('@exchange/libs/modals/src/lib/common/ErrorModal.vue'));

const props = __props;

const {
  loading,
  error,
  createPromise: getData,
} = usePromiseWithCB(
  async () => {
    await accountService.getAccountId({ useSubaccount: false });
    await Promise.all([accountService.fetchHolderUser(), featureRestrictionsService.get()]);
  },
  false,
  () => {
    modalService.substitute(
      shallowRef(ErrorModal),
      {
        variant: props.variant,
        titleKey: 'fundamentals.unavailableError.title',
        messageKey: 'fundamentals.unavailableError.text',
      },
      {
        'x-error-close': () => {
          modalService.clear();
        },
      },
      { variant: props.variant },
    );
  },
);

getData();

return (_ctx: any,_cache: any) => {
  const _component_ot_spinner = _resolveComponent("ot-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ot_spinner, {
            black: __props.variant === 'light'
          }, null, 8, ["black"])
        ]))
      : _createCommentVNode("", true),
    (!_unref(loading) && !_unref(error))
      ? _renderSlot(_ctx.$slots, "default", { key: 1 })
      : _createCommentVNode("", true)
  ]))
}
}

})